import { clientId } from "./client-id";

const newsletterSubscribeLink = document.getElementById("newsletter-subscribe");
const newsletterUnsubscribeLink = document.getElementById("newsletter-unsubscribe");

// When opened from the mobile apps the account console runs inside a
// WebView, where a new tab is pointless (Android) or broken (iOS)
const isMobileApp = clientId === "pennyios" || clientId === "pennyandroid";

if (newsletterSubscribeLink && newsletterUnsubscribeLink && !isMobileApp) {
    newsletterSubscribeLink.setAttribute('target', '_blank');
    newsletterUnsubscribeLink.setAttribute('target', '_blank');
}
